const imageMap = {
    'Solid Black': 'color-black',
    'Obsidian Black Metallic': 'color-black-obsidian',
    'Midnight Silver Metallic': 'color-grey',
    'Silver Metallic': 'color-silver',
    'Stealth Grey': 'color-stealth-grey',
    'Deep Blue Metallic': 'color-blue',
    'Red Multi-Coat': 'color-red',
    'Pearl Multi-Coat': 'color-white',
    'Pearl White Multi-Coat': 'color-white',
    'Ultra Red': 'color-red-ultra',
    'Lunar Silver': 'color-lunar-silver',
}

const onlyTextRegex = /[^a-z0-9]/g

function createImageKey(description) {
    return description.toLowerCase().replace(onlyTextRegex, '')
}

const normalizedImageMap = Object.keys(imageMap).reduce(
    (target, imageKey) => ({
        ...target,
        [createImageKey(imageKey)]: imageMap[imageKey],
    }),
    {}
)

export function getColorSwatchImage(description) {
    const imageKey = createImageKey(description)
    let color = normalizedImageMap.hasOwnProperty(imageKey) ? normalizedImageMap[imageKey] : undefined

    // if exact match was not found, get the color by testing if a simple color name is in the string
    if (!color) {
        const simpleColor = ['black', 'red', 'white', 'blue', 'silver'].find(
            simpleColor => imageKey.indexOf(simpleColor) > -1
        )
        if (simpleColor) {
            color = `color-${simpleColor}`
        }
    }
    return color ? `/assets/images/swatches/${color}.jpg` : null
}
